import { isNil } from 'lodash';

import type { DOMRect, ElementDirection } from 'types';

const GUTTER = 8;

const getDocumentWidth = (): number | undefined | null => document && document.body && document.body.clientWidth;

export const getElementInfo = (element?: HTMLElement | null): DOMRect | undefined | null => (element ? element.getBoundingClientRect() : null);

export const getElementDirection = (target?: HTMLElement | null, element?: HTMLElement | null): ElementDirection | undefined | null => {
  const targetInfo = getElementInfo(target);
  const elementInfo = getElementInfo(element);

  if (isNil(targetInfo) || isNil(elementInfo)) {
    return null;
  }

  const { top: targetTop, left: targetLeft, width: targetWidth } = targetInfo;
  const { width: elementWidth, height: elementHeight } = elementInfo;
  const documentWidth = getDocumentWidth() ?? 0;
  const targetCenter = targetLeft + (targetWidth / 2);
  const direction: ElementDirection = {
    vertical: 'top',
    horizontal: 'center'
  };

  if ((elementHeight + GUTTER) > targetTop) {
    direction.vertical = 'bottom';
  }

  if (targetCenter + elementWidth > documentWidth) {
    direction.horizontal = 'left';
  } else if ((targetCenter - elementWidth) / 2 < 0) {
    direction.horizontal = 'right';
  }

  return direction;
};

export const getElementPosition = (target?: HTMLElement | null, element?: HTMLElement | null): number | undefined | null => {
  const targetInfo = getElementInfo(target);
  const elementInfo = getElementInfo(element);

  if (isNil(targetInfo) || isNil(elementInfo)) {
    return null;
  }

  const { height: targetHeight } = targetInfo;
  const { height: elementHeight } = elementInfo;
  const direction = getElementDirection(target, element);

  if (isNil(direction)) {
    return null;
  }

  if (direction.vertical === 'top') {
    return elementHeight + GUTTER;
  }

  return targetHeight + GUTTER;
};
